import React from 'react';
import { MiniCta } from '../CtaBlock';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-94" data-mp="1hjhcdkdbduza">
      <div className="mx-auto max-w-4xl" data-id="element-95" data-mp="1cko9elvnlmdd">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-forge-light" data-id="element-96" data-mp="1clpjoo4ui4u1">
          🎁 Inoltre riceverai gratis
        </p>
        <h2 className="mt-3 text-center font-display text-4xl font-bold uppercase leading-none text-bone sm:text-6xl" data-id="element-97" data-mp="25adat0c9zofi">
          5 Bonus Esclusivi
        </h2>

        <ul className="mt-10 space-y-5" data-id="element-98" data-mp="208o23rcizmul">
          {bonuses.map(bonus => <li key={bonus.tag} className="overflow-hidden rounded-2xl border border-ink-500 bg-ink-700" data-id="element-99" data-mp="1w7c5h1v8i1cw">
              <div className="bg-white p-3 sm:p-4" data-id="element-100" data-mp="ktqfjehjvvqb">
                <img src={bonus.image} alt={`Mockup del ${bonus.title}`} className="mx-auto w-full max-w-lg" width={1256} height={1256} loading="lazy" data-id="element-101" data-mp="kvbctbv91srv" />
              </div>
              <div className="p-5 sm:p-6" data-id="element-102" data-mp="1jrylul3z7q62">
                <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-103" data-mp="15t8mszxljgf2">
                  <span className="rounded-md bg-forge px-2.5 py-1 font-display text-[13px] font-bold uppercase tracking-wide text-white" data-id="element-104" data-mp="1as1qy1qztv2k">
                    🎁 {bonus.tag}
                  </span>
                  <span className="font-display text-sm font-bold uppercase tracking-wide text-arc-light" data-id="element-105" data-mp="10tvq7ngxauza">
                    Valore: <span className="text-bone" data-id="element-106" data-mp="n2qvmzsewsvt">{bonus.value}</span>
                  </span>
                </div>
                <h3 className="mt-3 font-display text-xl font-bold uppercase leading-tight text-bone sm:text-2xl" data-id="element-107" data-mp="r3avwc8a8cm6">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[15px] font-semibold leading-snug text-arc-light" data-id="element-108" data-mp="i3ecoq4nw5yi">
                  {bonus.promise}
                </p>
                <p className="mt-2 text-[14px] leading-relaxed text-mute" data-id="element-109" data-mp="2jtlhrhsdboew">{bonus.text}</p>
              </div>
            </li>)}
        </ul>

        <MiniCta label="Voglio i 5 bonus gratis" data-id="element-110" data-mp="2f00m3we8z6iv" />
      </div>
    </section>;
}